import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function ArmazenaNavegacaoReducer(state = initialState.navegacao, action){
    switch(action.type) {
        case types.ARMAZENA_NAVEGACAO:
            
            return action.navegacao;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/ArmazenaNavegacaoReducer.js
 **/